import { ag_ad_click_log, ag_ad_impression_log } from "../log";
import { get_ag_ad, init_ag_toggle_sortables } from "./ag_js_util";
import { sleep } from "./general_util";


function handle_ad_visibility(entries:IntersectionObserverEntry[]) {
    const entry = entries[0];
    const target_el = entry.target;
    if (!entry.isIntersecting) return;
    if (! ($(target_el).is(":visible") && $(target_el).css("visiblity") != "hidden") ) return;

    const ad_id = target_el.getAttribute("ag-ad-id");
    ag_ad_impression_log(ad_id);
};

if ($("[ag-ad-block]").length) {
    const ad_resize_observer = new ResizeObserver(entries => {
        for (let entry of entries) {
            const el = entry.target;
            const cutoff_width = parseInt(el.getAttribute("cutoff-width"));
            if (!Number.isNaN(cutoff_width)) {
                if (el.clientWidth < cutoff_width) {
                    $(el).css({ visibility: "hidden"});
                } else {
                    $(el).css({ visibility: ""});
                }
            };
        };
    });

    const visibility_observer_options:IntersectionObserverInit = {
        root: null, //viewport
        threshold: 0.1 //10% of element must be visible to trigger (needs to be kinda low for vertical ads that span more than 1 scroll)
    };
    const visibility_observer = new IntersectionObserver(handle_ad_visibility, visibility_observer_options)


    document.querySelectorAll("[ag-ad-block]").forEach(el => {
        const ad_id:string = el.getAttribute("ag-ad-id");
        get_ag_ad(ad_id).then(ad_html => {
            el.innerHTML = ad_html;
            el.setAttribute("cutoff-width", (el.firstChild as HTMLElement).getAttribute("cutoff-width"));

            ad_resize_observer.observe(el);
            visibility_observer.observe(el);

            el.addEventListener("click", function() {
                const ad_id = this.getAttribute("ag-ad-id");
                ag_ad_click_log(ad_id);
            });
        }).catch(e => {

        });

    });
};

$("[ag-linkedInput]").each(function(index:number, el:HTMLInputElement) {
    const linkedInput_id:string = el.getAttribute("target");
    if (linkedInput_id == undefined || linkedInput_id == null) return;
    const linkedInput:JQuery<HTMLElement> = $(linkedInput_id);
    if (linkedInput.length == 0) return;
    $(el).on("focusout", () => {
        linkedInput.val($(el).val());
        linkedInput[0].dispatchEvent(new Event("change"));
    });
    linkedInput.on("input", () => {
        $(el).val(linkedInput.val());
    });
});

$(".swappable-inputs").each(function(index:number, el:HTMLElement) {
    const swapBtn = el.querySelector(".swap-icon");
    if (swapBtn == undefined || swapBtn == null) return;
    const input1:JQuery<HTMLInputElement> = $(el).find("input:first") as JQuery<HTMLInputElement>;
    const input2:JQuery<HTMLInputElement> = $(el).find("input:eq(1)") as JQuery<HTMLInputElement>;

    if (
        input1 == undefined ||
        input1 == null ||
        input1.length == 0 ||
        input2 == undefined ||
        input2 == null ||
        input2.length == 0
    ) return;

    swapBtn.addEventListener("click", function() {
        const val1:string = input1.val() as string;
        const query_type_1:string|undefined = input1.attr("query_type");
        const query_val_1:string|undefined = input1.attr("query_val");
        const val2:string = input2.val() as string;
        const query_type_2:string|undefined = input2.attr("query_type");
        const query_val_2:string|undefined = input2.attr("query_val");

        input1.val(val2);
        input2.val(val1);

        if (query_type_1 != undefined) input2.attr("query_type", query_type_1);
        if (query_val_1 != undefined) input2.attr("query_val", query_val_1);
        if (query_type_2 != undefined) input1.attr("query_type", query_type_2);
        if (query_val_2 != undefined) input1.attr("query_val", query_val_2);
    });
});

$(document).on("click", ".count-input [data-decrement]", function() {
    const $parentEl:JQuery<HTMLElement> = $(this).closest(".count-input");
    if ($parentEl.length == 0) return;
    const parentEl:HTMLElement = $parentEl[0];
    const input:HTMLInputElement = parentEl.querySelector("input");
    if (input == undefined) return;
    const min_str:string|undefined = input.getAttribute("min");
    let min:number|null = null;
    if (min_str != undefined) {
        min = parseInt(min_str);
    }
    const max_str:string|undefined = input.getAttribute("max");
    let max:number|null = null;
    if (max_str != undefined) {
        max = parseInt(max_str);
    };

    const decrement:HTMLElement = this;
    let decrementStep:number
    if (decrement != undefined) {
        let decrementStep_attr:string = decrement.getAttribute("step");
        if (decrementStep_attr != undefined && decrementStep_attr != null) {
            decrementStep = parseInt(decrementStep_attr);
        } else {
            decrementStep = 1;
        };
    };

    var val:number = parseInt(input.value);
    if (Number.isNaN(val)) {
        val = decrementStep;
    } else {
        val -= decrementStep;
    };
    if (min != null) {
        if (val < min) val = min;
    }
    input.value = val.toString();

    $(input).trigger("input");
});
$(document).on("click", ".count-input [data-increment]", function() {
    const $parentEl:JQuery<HTMLElement> = $(this).closest(".count-input");
    if ($parentEl.length == 0) return;
    const parentEl:HTMLElement = $parentEl[0];
    const input:HTMLInputElement = parentEl.querySelector("input");
    if (input == undefined) return;
    const min_str:string|undefined = input.getAttribute("min");
    let min:number|null = null;
    if (min_str != undefined) {
        min = parseInt(min_str);
    }
    const max_str:string|undefined = input.getAttribute("max");
    let max:number|null = null;
    if (max_str != undefined) {
        max = parseInt(max_str);
    };

    const increment:HTMLElement = this;
    let incrementStep:number
    if (increment != undefined) {
        let incrementStep_attr:string = increment.getAttribute("step");
        if (incrementStep_attr != undefined && incrementStep_attr != null) {
            incrementStep = parseInt(incrementStep_attr);
        } else {
            incrementStep = 1;
        };
    };

    var val:number = parseInt(input.value);
    if (Number.isNaN(val)) {
        val = incrementStep;
    } else {
        val += incrementStep;
    };
    if (max != null) {
        if (val > max) val = max;
    }
    input.value = val.toString();

    $(input).trigger("input");
});

$("[ag-autoresize]").on("input", function() {
    this.style.height = "auto";
    this.style.height = `${this.scrollHeight}px`;
});

//gets part of TextBox text currently selected(highlighted) by user for applying styling
function getTextSelection($reviewTextBox:JQuery<HTMLElement>) {
    let rangeobj = document.createRange();
    let selectobj = window.getSelection();

    if (selectobj.toString().length == 0) {
      rangeobj.selectNodeContents($reviewTextBox[0]);
      rangeobj.collapse(false);
      selectobj.removeAllRanges();

      selectobj.addRange(rangeobj);
    }
  };
// Listens for clicks on elements with data-ag-toggle='text-bold'.
// Applies 'bold' command to selected text in the targeted element.
$(document).on("click", "[data-ag-toggle='text-bold']", function(this: any,event:Event) {
    event.preventDefault();
    let textBox = $(`#${$(this).attr("data-ag-target")}`);
	getTextSelection(textBox);
    $(textBox).trigger("focus");
    document.execCommand('bold', false, null); // apply command
});

// Listens for clicks on elements with data-ag-toggle='text-italic'.
// Applies 'italic' command to selected text in the targeted element.
$(document).on("click", "[data-ag-toggle='text-italic']", function(this: any,event:Event) {
    event.preventDefault();
    let textBox = $(`#${$(this).attr("data-ag-target")}`);
    getTextSelection(textBox);
    $(textBox).trigger("focus");
    document.execCommand('italic', false, null); // apply command
});

// Listens for clicks on elements with data-ag-toggle='text-list'.
// Applies 'insertUnorderedList' command to selected text in the targeted element.
$(document).on("click", "[data-ag-toggle='text-list']", function(this: any,event:Event) {
    event.preventDefault();
    let textBox = $(`#${$(this).attr("data-ag-target")}`);
    getTextSelection(textBox);
    $(textBox).trigger("focus");
    document.execCommand('insertUnorderedList', false, null); // apply command
});

// Listens for clicks on elements with data-ag-toggle='text-strikethrough'.
// Applies 'strikethrough' command to selected text in the targeted element.
$(document).on("click", "[data-ag-toggle='text-strikethrough']", function(this: any,event:Event) {
    event.preventDefault();
    let textBox = $(`#${$(this).attr("data-ag-target")}`);
    getTextSelection(textBox);
    $(textBox).trigger("focus");
    document.execCommand('strikethrough', false, null); // apply command
});

$(document).on("click", "[data-ag-toggle='copy-link']", function(this: any,event:Event) {
    event.preventDefault();
    let $inputWithLink:JQuery<HTMLInputElement>;
    let inputWithLink:HTMLInputElement;
    if (this.tagName == "INPUT") {
        inputWithLink = this;
    } else {
        let inputWithLink_selector:string|undefined = $(this).attr("data-ag-target");
        if (inputWithLink_selector == undefined) return;
        $inputWithLink = $(inputWithLink_selector);
        if (!$inputWithLink.length) return;
        inputWithLink = $inputWithLink[0];
    };
    if (inputWithLink === undefined) return;

    if ($(this).attr("data-ag-message") !== undefined) {
        let newEl:JQuery<HTMLElement> = $(`<div class='alert alert-secondary m-0 p-2 position-absolute top-0 end-0 mt-n3' style='margin-right:-110% !important;' role='alert'>${$(this).attr("data-ag-message")}</div>`);
        $(this).append(newEl);
        setTimeout(()=>{$(newEl).remove()},3000);
    };

    inputWithLink.select();
    inputWithLink.setSelectionRange(0,99999);//for mobile
    navigator.clipboard.writeText(inputWithLink.value);
});

init_ag_toggle_sortables();

function checkVideoInViewport(video:HTMLVideoElement) {
    const rect = video.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // Check if the video is fully in the viewport
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= windowHeight &&
      rect.right <= windowWidth
    );
};

window.addEventListener("scroll", function() {
    $("video[play-in-view]").each(function(index,videoEl:HTMLVideoElement) {
        if (checkVideoInViewport(videoEl)) {
            videoEl.play();
        } else {
            videoEl.pause();
        };
    });
});
window.addEventListener("resize", function() {
    $("video[play-in-view]").each(function(index,videoEl:HTMLVideoElement) {
        if (checkVideoInViewport(videoEl)) {
            videoEl.play();
        } else {
            videoEl.pause();
        };
    });
});

(function () {
    window.addEventListener("load", function () {

        let lazyYoutubeVideos:HTMLIFrameElement[] = Array.from(document.querySelectorAll("iframe[lazy-load]")); // Get all youtube videos with lazy-load attribute
        lazyYoutubeVideos.forEach(function(lazyYoutubeVideo) {
            lazyYoutubeVideo.setAttribute("src",lazyYoutubeVideo.getAttribute("videoURL"));
        });

        let lazyVideos:HTMLVideoElement[] = Array.from(document.querySelectorAll("video[lazy-load]"));

        if ("IntersectionObserver" in window) {
            var lazyVideoObserver:IntersectionObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                for (var source in video.target.children) {
                    var videoSource:HTMLSourceElement = video.target.children[source] as HTMLSourceElement;
                    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                    };
                };

                (video.target as HTMLVideoElement).load();
                video.target.classList.remove("lazy");
                lazyVideoObserver.unobserve(video.target);
                };
            });
            });

            lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
            });
        };
    });
})();

